export default function LoadingSpinner({ size = 100 }) {
  const multiplier = size / 100

  return (
    <svg
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${size} ${size}`}
      preserveAspectRatio="xMidYMid"
      data-component="loading-spinner"
    >
      <circle
        cx={0.5 * size}
        cy={0.5 * size}
        fill="none"
        stroke="#6cca98"
        strokeWidth={0.08 * size}
        r={0.44 * size}
        strokeDasharray={`${207.34511513692632 * multiplier} ${
          71.11503837897544 * multiplier
        }`}
        transform={`rotate(${143.937 * multiplier} ${0.5 * size} ${
          0.5 * size
        })`}
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values={`0 ${0.5 * size} ${0.5 * size}; 360 ${0.5 * size} ${
            0.5 * size
          }`}
          keyTimes="0;1"
          dur="1s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  )
}
